/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

@use '../../../variables';

#PatientRecord {
  display: grid;
  width: 100%;

  #patient-record-header {
    padding-bottom: 10px;
    align-items: center;
  }

  .inverted-button {
    background-color: variables.$color-primary-50;
    color: variables.$color-black;
    border: variables.$color-primary solid 1px;
  }

  .rounded {
    border-radius: 99px;
  }

  .note-list {
    border: variables.$color-corpuls-secondary-50 solid 1px;
    border-radius: 4px;
  }
}
